import React from 'react';
import { ElementConfigType } from '../store/PageEditorStore';
import ComponentItemRenderProd from './ComponentItemRenderProd';
import { MyComponentType } from '@/pages2/DetailedDescription/component-factory/component-types';
import { ComponentIdEnum } from '@/pages2/DetailedDescription/component-factory/ComponentIdEnum';

interface Iheight {
  height?: string;
  className?: string;
  tip?: string;
}

type Props = ElementConfigType & Iheight;

export const ComponentBasicRenderProd: MyComponentType<Props> = (props: Props) => {
  const { elements, styles, className } = props;

  return (
    <>
      <div className={className} style={Object.assign({}, styles)}>
        {elements.map((item) => (
          <ComponentItemRenderProd {...item} key={item.nodeId} />
        ))}
      </div>
    </>
  );
};

ComponentBasicRenderProd.definition = {
  // id: 'Basic-Component', // 基本容器
  id: ComponentIdEnum.BASIC_COMPONENT, // 基本容器
  name: '基本容器',
  icon: '',
  privateSchema: [],
  config: {},
  schema: [],
};
